var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "大V审核",
        visible: _vm.dialogVisible,
        width: "800px",
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            "max-height": "50vh",
            "overflow-y": "auto",
            padding: "15px 30px",
            "background-color": "#f6f6f6"
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "80px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "会员编号" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "60%" },
                    model: {
                      value: _vm.form.numbers,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "numbers", $$v)
                      },
                      expression: "form.numbers"
                    }
                  }),
                  _vm.tag !== "sta4"
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "20px" },
                          attrs: { type: "primary" },
                          on: { click: _vm.clickImport }
                        },
                        [_vm._v("导入会员")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.tag === "sta2"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "派系" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "300px" },
                          attrs: { multiple: "", placeholder: "请选择" },
                          model: {
                            value: _vm.form.groups,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "groups", $$v)
                            },
                            expression: "form.groups"
                          }
                        },
                        _vm._l(_vm.groupList, function(item) {
                          return _c("el-option", {
                            key: item.key,
                            attrs: {
                              label: item.key + " " + item.value,
                              value: item.key
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.tag === "sta3"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "上级等级" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "300px" },
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.form.grade,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "grade", $$v)
                            },
                            expression: "form.grade"
                          }
                        },
                        _vm._l(_vm.gradeList, function(item) {
                          return _c("el-option", {
                            key: item.tag,
                            attrs: { label: item.name, value: item.tag }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.tag === "sta4"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "过滤会员" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "多个以逗号分割" },
                        model: {
                          value: _vm.form.filters,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "filters", $$v)
                          },
                          expression: "form.filters"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogVisible = false
                }
              }
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.clickSubmit } },
            [_vm._v("提交")]
          )
        ],
        1
      ),
      _c("input", {
        directives: [
          { name: "show", rawName: "v-show", value: false, expression: "false" }
        ],
        ref: "import",
        attrs: { type: "file", accept: ".xlsx" },
        on: {
          change: function($event) {
            return _vm.onExcelImport($event)
          }
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }